<div class="notif-wrapper">

  

  <!-- Notification list (paged) -->
  <div class="notif-list-container">
    <!-- Header -->
    <div class="notif-header">
      <div class="notif-title-row">
        <h2 class="notif-title">
          List of Notifications
          <span class="notif-badge" *ngIf="notificationsList?.length">
            {{ notificationsList.length }}
          </span>
        </h2>
        <div class="notif-actions" *ngIf="notificationsList.length > 0">
          <button class="notif-action-btn mark-read-btn" title="Mark selected as read" (click)="readNotification()">
            <i class="fa-solid fa-check"></i>
          </button>
          <button class="notif-action-btn delete-btn" title="Delete selected" (click)="deleteNotification()">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="table-responsive-wrapper">
    <ng-container *ngFor="let note of pagedNotifications; let i = index">

      <!-- Date-group header: show when date changes within the current page -->
      <div class="notif-date-group"
        *ngIf="i === 0 || (pagedNotifications[i-1].timestamp | date:'MMM d, y') !== (note.timestamp | date:'MMM d, y')">
        {{ note.timestamp | date:'MMM d, y' }}
        <span class="group-count">
          ({{ getDateGroupCount((note.timestamp | date:'MMM d, y') ?? '') }})
        </span>
      </div>

      <!-- Notification row -->
      <div class="notif-row"
        [class.notif-unread]="note.status === 'unread'"
        [class.notif-navigable]="note.navigation"
        [title]="note.navigation ? 'Click to open' : ''"
        (click)="onNotificationClick(note)">

        <!-- Checkbox (stop-propagation so clicking it doesn't navigate) -->
        <div class="notif-checkbox-col" (click)="$event.stopPropagation()">
          <input type="checkbox"
            class="notif-checkbox"
            name="checkBox2"
            [checked]="note.isChecked"
            (change)="isCheckBox($any($event.target).checked, note)">
        </div>

        <!-- Avatar -->
        <div class="notif-avatar" [ngClass]="getAvatarClass(note)">
          {{ getAvatarInitial(note) }}
        </div>

        <!-- Message + optional link indicator -->
        <div class="notif-content">
          <div class="notif-message" [class.notif-message-bold]="note.status === 'unread'">
            {{ note.message }}
          </div>
        </div>

        <!-- Date & unread dot -->
        <div class="notif-meta">
          <span class="notif-date">{{ note.timestamp | date:'M/d/yyyy' }}</span>
          <span class="notif-dot" *ngIf="note.status === 'unread'"></span>
        </div>
      </div>

    </ng-container>
    </div>

    <!-- Empty state -->
    <!-- <div class="notif-empty" *ngIf="notificationsList && notificationsList.length === 0">
      <i class="fa-regular fa-bell"></i>
      <p>No notifications</p>
    </div> -->
        
    <div class="empty-state-container" *ngIf="notificationsList.length === 0">
    <img src="assets/img/e-notification.png" class="empty-state-icon" alt="No entries">
    <p class="empty-state-title">No Notifications Yet!</p>
    <p class="empty-state-subtitle">There are no notifications under here.</p>
   </div>

    <div class="nav-buttons" *ngIf="notificationsList.length > 0">
      <button class="prev" (click)="prevPage()" [disabled]="currentPage === 1">&lt;&lt; Prev</button>
      <button class="next" (click)="nextPage()" [disabled]="currentPage === totalPages">Next &gt;&gt;</button>
    </div>
  </div>

  <!-- Pagination -->
<!-- <div class="nav-buttons" *ngIf="notificationsList.length > 0">
  <label class="pag-info">
    Showing <span>{{ fromCount }}</span>
    to <span>{{ toCount }}</span>
    of <span>{{ notificationsList.length }}</span> entries
  </label>

  <div class="pag-btns">
    <button class="prev" (click)="prevPage()" [disabled]="currentPage === 1">
      &lt;&lt; Prev
    </button>

    <button class="next" (click)="nextPage()" [disabled]="currentPage === totalPages">
      Next &gt;&gt;
    </button>
  </div>
</div> -->



</div>

<ngx-spinner size="medium" type="ball-clip-rotate"></ngx-spinner>